// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Own Components
import { FormFieldComponent } from './form-field.component';
import { PipesModule } from 'libraries/pipes/pipes.module';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { FieldDescriptionModule } from './components/field-description/field-description.module';
import { ClickOutsideModule } from 'libraries/ui_clickOutside/clickOutside.module';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";
import { NgxFormErrorModule } from "ngx-form-error";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PipesModule,
        NgxFormErrorModule,
        BtnModule,
        FieldDescriptionModule,
        ClickOutsideModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    declarations: [
        FormFieldComponent
    ],
    exports: [
        FormFieldComponent
    ],
})

export class FormFieldModule { }
